export const getNextStoreOpen = (timings) => {
  const daysOfWeek = [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
  ];
  const todayIndex = new Date().getDay();

  const formatTime12Hour = (time24) => {
    const [hourStr, minute] = time24.split(":");
    let hour = parseInt(hourStr, 10);
    const ampm = hour >= 12 ? "PM" : "AM";
    hour = hour % 12 || 12;
    return `${hour}:${minute} ${ampm}`;
  };

  for (let i = 1; i <= 14; i++) {
    const nextDayIndex = (todayIndex + i) % 7;
    const nextDayName = daysOfWeek[nextDayIndex];
    const nextDayTiming = timings?.find(
      (t) => t.day === nextDayName && t.startTime && t.endTime
    );

    if (nextDayTiming) {
      return `${nextDayName} at ${formatTime12Hour(nextDayTiming.startTime)}`;
    }
  }

  return null;
};
